export default "__VITE_ASSET__HlAt1MvC__"